import { take } from "rxjs";
import { Component, Input, inject } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { DashboardsService, ResponseErrorHandlerService } from "../../shared";
import { DashboardEditComponent } from "./dashboard-edit/dashboard-edit.component";
import { IDashboardModel, IDashboardUpdateResponse } from "../../views-interfaces/dashboard-model.interface";
import { JumpstartComponentsWkIconsModule, JumpstartComponentsModule } from "@wk/components-v3-angular17";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "wk-settings-rename-dashboard",
    templateUrl: "./settings-rename-dashboard.component.html",
    styleUrl: "./settings-rename-dashboard.component.scss",
    host: { class: "wk-srd" },
    imports: [JumpstartComponentsWkIconsModule, JumpstartComponentsModule, TranslatePipe],
})
export class SettingsRenameDashboardComponent {
    private dashboardsService = inject(DashboardsService);
    private modalService = inject(BsModalService);
    private responseErrorHandlerService = inject(ResponseErrorHandlerService);

    bsModalRef?: BsModalRef;
    loading = false;

    @Input() selectedDashboard: IDashboardModel;

    constructor() {}

    promptForEdition(dashboard: IDashboardModel) {
        this.bsModalRef = this.modalService.show(DashboardEditComponent, {
            initialState: {
                title: "Settings.EditDashboardTitle",
                dashboard: structuredClone(dashboard),
                callback: (aDashboard: IDashboardModel) => this.saveDashboard(aDashboard),
            },
            class: "custom-modal-rename-dashboard",
        });
    }

    saveDashboard(dashboard: IDashboardModel) {
        this.loading = true;
        const saveData = {
            Title: dashboard.Title,
        };
        this.dashboardsService
            .updateDashboard(dashboard.Id, saveData)
            .pipe(take(1))
            .subscribe(
                (data: IDashboardUpdateResponse) => {
                    if (data && data != null && data.Code === 200) {
                        this.dashboardsService.reload(true);
                        this.bsModalRef?.hide();
                        this.loading = false;
                        this.responseErrorHandlerService.showPopup({
                            typeLayout: "SUCCESS",
                            messageCode: "successfullySaved",
                        });
                        if (this.selectedDashboard && data.Dashboard?.Id === this.selectedDashboard?.Id) {
                            this.dashboardsService.titleChangedEmitter.next(data.Dashboard?.Title);
                        }
                    }
                },
                () => {
                    this.loading = false;
                    this.bsModalRef?.hide();
                    this.responseErrorHandlerService.showPopup({
                        typeLayout: "ERROR",
                        messageCode: "CancelSaved",
                    });
                },
            );
    }
}
